<template>
  <div>
    <van-nav-bar left-text="消息通知" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <div class="system">
      <img v-if="data.mainFileUrl" :src="data.mainFileUrl">
      <div class="title">
        {{ data.name }}
      </div>
      <div class="time">
        {{ formatTime(data.createTime) }}
      </div>
      <div class="content">
        {{ data.moduleInfo }}
      </div>
      <div v-if="data.fileUrl && JSON.parse(data.fileUrl).length > 0">
        <img v-for="(item, index) in JSON.parse(data.fileUrl)" :key="index" :src="item.url" class="file_img">
      </div>
    </div>
  </div>
</template>
<script>
import { getNoticeDetail } from '@/api/index'
export default {
  data() {
    return {
      data: {}
    }
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    onClickLeft() {
      this.$router.push({ path: '/message', query: { active: 4 } })
    },
    getDetail() {
      const { id } = this.$route.query;
      getNoticeDetail(id).then(res => {
        console.log(res);
        this.data = res
      })
    },
    formatTime(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
}
</script>
<style lang="less" scoped>
.system {
  width: 90%;
  margin: 0 auto;

  img {
    width: 100%;
  }

  .title {
    line-height: 20px;
    color: rgb(16, 16, 16);
    font-weight: bold;
  }

  .time {
    color: rgb(16, 16, 16);
    line-height: 20px;
    margin: 10px 0;
  }

  .content {
    color: rgb(16, 16, 16);
    line-height: 20px;
  }

  .file_img {
    margin-top: 10px;
  }
}
</style>